import { FC } from "react";

import { Typography } from "@/shared/ui";
import { calculateAge } from "@/utils";

import { Tag } from "../../../tag";

import styles from "./grid-profile-card.module.scss";
import { GridProfileCardProps } from "./grid-profile-card.types";

const GridProfileCard: FC<GridProfileCardProps> = ({ firstName, dateOfBirth, isFreeTonight }) => {
  return (
    <div className={styles.mainInfo}>
      <div className={styles.row}>
        <div className={styles.name}>
          <Typography variant="subheadline">{firstName}</Typography>
          <Typography variant="caption-2">{calculateAge(dateOfBirth)}</Typography>
        </div>
        {isFreeTonight && <Tag label="Free Tonight" variant="green" className={styles.tag} />}
      </div>
    </div>
  );
};

export { GridProfileCard };
